import { withTranslation } from 'react-i18next';
import { Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import ReactJson from 'react-json-view'

const render = (json, isLoading) => (
  <>
    <div className="d-flex align-items-center justify-content-between">
      <p className="fs-4 fw-semibold" />
    </div>

    {isLoading ? (
      <div className="skeleton card" style={{ height: '100px' }} />
    ) : (
      <ReactJson src={JSON.parse(json)} theme='bright:inverted' />
    )}
  </>
);

const JsonViewer = () => {
  const { audit, isLoading } = useSelector(
    createSelector(
      (store) => store.Audit,
      (slice) => ({
        isLoading: slice.isLoading,
        audit: slice.audit,
      })
    )
  );

  if (!audit || !Object.keys(audit)?.length) {
    return <div></div>;
  }

  return (
    <Row className="g-3">
      {render(audit.event, isLoading)}
    </Row>
  );
};

export default withTranslation()(JsonViewer);
